import { render, staticRenderFns } from "./napo.vue?vue&type=template&id=740b4526"
import script from "./napo.vue?vue&type=script&lang=ts"
export * from "./napo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports